import React, { ReactNode } from 'react';
import styled from 'styled-components';
import {
  Popover,
} from 'antd';
import { useSelector } from 'react-redux';
import { selectProfileLoading } from 'Selector/ProfileShareSelector';
import ProfileShareIcons from 'Components/share/ProfileShareIcons';
import { IsMobile } from 'Utils/UtilityFunctions';
import {
  primaryFont, secondaryFont, wMedium, primaryHeadingColor, maxWidth, retina,
} from '../../../Utils/utilsStyle';

// svgs
import ShareIcon from '../assets/svgIcons/ShareIcon';
import SkeletonCustom from '../skeleton/SkeletonCustom';

const ContentWrapper = styled.div`
  .icon {
    svg {
      height: 24px;
      width: 20px;
    }
  }
  h2 {
    font-size: 28px;
    color: ${primaryHeadingColor};
    font-weight: 800;
    font-family: ${secondaryFont};
    letter-spacing: -0.45px;
    line-height: 1.111 !important;
    margin: 0;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 20px;
    }
  }
  p {
    font-size: 16px;
    color: #7E7E7E !important;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    letter-spacing: -0.4px;
    margin: 0;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 12px;
    }
  }
  .upperPart{
    padding: 20px 23px 0 23px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 20px 20px 0 17px;
    }
  }

  .userInfoSection {
    margin-top: 18px;
  }
  .linksSection {
    margin-top: 24px;
    padding: 18px 23px 20px 23px;
    background-color: #F8F8F8;
    border-radius: 0 0 20px 20px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      margin-top: 12px;
      padding: 15px 20px 20px 17px;
      border-radius: 0 0 10px 10px;
    }
  }
  .linkMarginTop {
    padding-top: 18px;
  }

  .teams-share-button{
    display: flex;
    flex-direction: row-reverse;

    a{
      margin-right: 5px;
    }
  }
  .loading{
    font-family: ${primaryFont};
    margin: 0;
  }
`;

type Props = {
  subject: string,
  isPerson?: boolean
  children: ReactNode,
} & typeof defaultProps;

const defaultProps = {
  isPerson: false,
};

const ProfileSharePopup: React.FC<Props> = function ProfileSharePopup({
  subject, children, isPerson,
}) {
  const loadingLink = useSelector(selectProfileLoading);
  const isMob = IsMobile();
  const content = (
    <ContentWrapper>
      <div className="upperPart">
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center icon"
            style={{
              marginRight: '10px',
            }}
          >
            <ShareIcon color="#000000" />
          </div>
          <div>
            <h2 className="primary-color text-center">
              Share profile
            </h2>
          </div>
        </div>
      </div>
      <div className="linksSection">
        {loadingLink
          ? (
            <>
              {[1, 2, 3].map(() => <SkeletonCustom width="100%" height="24px" margin="0 4px" />)}
            </>
          ) : <ProfileShareIcons subject={subject} isPerson={isPerson} />}
      </div>
    </ContentWrapper>
  );

  return (
    <Popover
      placement="bottomRight"
      content={content}
      overlayClassName="share-profile-dropdown"
      trigger="click"
      {...(isMob ? {} : { getPopupContainer: (e: HTMLElement) => e })}
      arrow={false}
      align={{ offset: [0, -40] }}
      getPopupContainer={(e: HTMLElement) => e}
    >
      <div>
        {children}
      </div>
    </Popover>
  );
};

ProfileSharePopup.defaultProps = defaultProps;
export default ProfileSharePopup;
